/* ==========================================================================
   Shiok Booking Gate
   --------------------------------------------------------------------------
   Menahan Add to Cart untuk produk chef/assistant di SEMUA jalur masuk
   (halaman produk, quick add, product recommendation), meminta data booking
   sekali per keranjang, lalu menyerahkan kembali penambahan ke handler tema.

   Prinsip:
   - Data booking milik ACARA (cart attributes), bukan milik baris.
   - Kode ini TIDAK menambahkan produk utama ke keranjang. Tema yang melakukannya.
   - Surcharge: satu baris, quantity SELALU 1, sekali per order.
   - Fail open. Kalau apa pun gagal, pelanggan tetap bisa checkout.

   30-09-2026 (Boss): tanggal paling awal per produk (minDays dari metafield
   my_fields.min_lead_days, default 1 = besok), peringatan bayar hari ini di
   hari minDays sampai minDays + payWarnExtraDays - 1, dan copy jasa murni
   (disclaimer, kalimat kedatangan) hanya untuk serviceOnly. Satu booking per
   keranjang tetap berlaku, jadi syaratnya diambil dari produk TERBERAT di
   keranjang plus produk yang sedang ditambahkan. Untuk chef/assistant saja
   (minDays 1) semua jalur berperilaku persis seperti sebelumnya.
   ========================================================================== */

(function () {
  'use strict';

  var CFG = null;
  try {
    var el = document.getElementById('shiok-booking-gate-config');
    CFG = JSON.parse(el.textContent);
  } catch (e) {
    return; // tanpa konfigurasi, gerbang tidak aktif. Toko tetap jalan normal.
  }

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var ATTR = {
    date:     'Event Date',
    time:     'Booking Time',
    duration: 'Dining Duration',
    guests:   'Number of Guests',
    notes:    'Additional Notes',
    surcharge:'Last-Minute Surcharge'
  };

  var state = {
    form: null,          // form yang sedang ditahan
    variantId: null,
    booking: null,       // { date, time, duration, guests, notes }
    mode: 'add',         // 'add' = sedang menambah produk, 'edit' = mengubah dari keranjang
    rule: { days: 1, title: '', serviceOnly: true },  // syarat tanggal yang berlaku di modal
    addServiceOnly: true, // produk yang sedang ditambahkan adalah jasa murni
    reconciling: false,
    reconcileTimer: null
  };

  /* ======================================================================
     1. Waktu. SEMUA perhitungan diikat ke Asia/Singapore (UTC+8),
        bukan ke zona waktu browser pelanggan.
     ====================================================================== */

  var SGT_OFFSET_MIN = 8 * 60;

  // "sekarang" dalam komponen tanggal waktu Singapura
  function sgtNowParts() {
    var now = new Date();
    var utcMs = now.getTime() + now.getTimezoneOffset() * 60000;
    return new Date(utcMs + SGT_OFFSET_MIN * 60000);
  }

  // yyyy-mm-dd dari komponen lokal sebuah Date (tanpa lewat toISOString)
  function toDateString(d) {
    var y = d.getFullYear();
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var day = String(d.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + day;
  }

  function tomorrowSGT() {
    var d = sgtNowParts();
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + 1);
    return toDateString(d);
  }

  // Tanggal n hari dari hari ini, waktu Singapura. n = 1 sama dengan tomorrowSGT().
  function sgtPlusDays(n) {
    var d = sgtNowParts();
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + n);
    return toDateString(d);
  }

  // Berapa hari kalender dari hari ini (SGT) ke tanggal yyyy-mm-dd.
  function daysFromTodaySGT(dateStr) {
    var t = sgtNowParts();
    t.setHours(0, 0, 0, 0);
    var p = String(dateStr || '').split('-').map(Number);
    if (p.length !== 3 || !p[0]) return null;
    return Math.round((new Date(p[0], p[1] - 1, p[2]).getTime() - t.getTime()) / 86400000);
  }

  function niceDate(dateStr) {
    var d = sgtInstant(dateStr, '12:00 PM');
    return d ? d.toLocaleDateString('en-SG', {
      weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', timeZone: 'Asia/Singapore'
    }) : dateStr;
  }

  // "5:30 PM" -> { h: 17, m: 30 }
  function parse12h(t) {
    var m = /^(\d{1,2}):(\d{2})\s*(AM|PM)$/i.exec(String(t || '').trim());
    if (!m) return null;
    var h = parseInt(m[1], 10) % 12;
    if (/PM/i.test(m[3])) h += 12;
    return { h: h, m: parseInt(m[2], 10) };
  }

  // Instant absolut dari tanggal+jam yang DIANGGAP waktu Singapura.
  function sgtInstant(dateStr, timeStr) {
    if (!dateStr) return null;
    var hm = parse12h(timeStr) || { h: 0, m: 0 };
    var iso = dateStr + 'T' +
      String(hm.h).padStart(2, '0') + ':' +
      String(hm.m).padStart(2, '0') + ':00+08:00';
    var d = new Date(iso);
    return isNaN(d.getTime()) ? null : d;
  }

  // Jam dari SEKARANG sampai MULAI acara. Titik ukur = jam mulai (Booking Time).
  function hoursUntilEvent(dateStr, timeStr) {
    var start = sgtInstant(dateStr, timeStr);
    if (!start) return null;
    return (start.getTime() - Date.now()) / 3600000;
  }

  /* ======================================================================
     2. Band surcharge. Batas inklusif: tepat 24,0 jam masuk band $100.
     ====================================================================== */

  function bandFor(dateStr, timeStr) {
    if (!CFG.surcharge || !CFG.surcharge.enabled) return null;
    var hrs = hoursUntilEvent(dateStr, timeStr);
    if (hrs === null || hrs < 0) return null;
    var bands = CFG.surcharge.bands || [];
    for (var i = 0; i < bands.length; i++) {
      if (hrs <= bands[i].maxHours) return bands[i];
    }
    return null;
  }

  function bandSentence(b) {
    return b.sentence || ('within ' + b.maxHours + ' hours');
  }

  function money(n) {
    return '$' + Number(n).toFixed(2).replace(/\.00$/, '');
  }

  /* ======================================================================
     3. Cart API
     ====================================================================== */

  /* Penanda _sbg=1 dipasang di SEMUA permintaan milik gerbang sendiri, supaya
     pengamat perubahan keranjang bisa mengabaikannya tanpa perlu menebak lewat
     flag waktu. Versi sebelumnya memakai `!state.reconciling` sebagai syarat,
     dan itu ikut menelan perubahan dari LUAR: waktu tema menambahkan chef ke
     keranjang sementara satu reconcile masih berjalan, penjadwalannya dilewati
     dan surcharge tidak pernah ditambahkan. */
  var SELF = '_sbg=1';
  function selfUrl(path) { return ROOT + path + (path.indexOf('?') === -1 ? '?' : '&') + SELF; }

  function cartFetch(path, body) {
    return fetch(selfUrl(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function getCart() {
    return fetch(selfUrl('cart.js'), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); });
  }

  function setAttributes(attrs) { return cartFetch('cart/update.js', { attributes: attrs }); }
  function addItems(items)      { return cartFetch('cart/add.js', { items: items }); }
  function changeLine(key, patch) {
    var body = { id: key };
    if (patch.quantity !== undefined)   body.quantity = patch.quantity;
    if (patch.properties !== undefined) body.properties = patch.properties;
    return cartFetch('cart/change.js', body);
  }

  /* ======================================================================
     4. Klasifikasi baris keranjang
     ====================================================================== */

  function chefCountFor(variantId) {
    var entry = CFG.gatedVariants[String(variantId)];
    return entry && entry.chefCount ? entry.chefCount : 1;
  }

  function isGated(variantId)    { return Object.prototype.hasOwnProperty.call(CFG.gatedVariants, String(variantId)); }
  function isSurcharge(variantId){ return (CFG.surcharge.allVariantIds || []).indexOf(Number(variantId)) !== -1; }

  function entryFor(variantId)   { return CFG.gatedVariants[String(variantId)] || {}; }
  function minDaysFor(variantId) { var n = parseInt(entryFor(variantId).minDays, 10); return n > 0 ? n : 1; }
  // !== false: konfigurasi lama tanpa kunci ini tetap dianggap jasa murni.
  function isServiceOnly(variantId) { return entryFor(variantId).serviceOnly !== false; }

  // Syarat terberat dari sekumpulan variant: jumlah hari terbesar menang.
  function ruleFor(variantIds) {
    var r = { days: 1, title: '', serviceOnly: true };
    (variantIds || []).forEach(function (v) {
      var d = minDaysFor(v);
      if (d > r.days) { r.days = d; r.title = entryFor(v).productTitle || ''; }
      if (!isServiceOnly(v)) r.serviceOnly = false;
    });
    return r;
  }

  function splitCart(cart) {
    var chef = [], sur = [];
    (cart.items || []).forEach(function (it) {
      if (isGated(it.variant_id)) chef.push(it);
      else if (isSurcharge(it.variant_id)) sur.push(it);
    });
    return { chef: chef, sur: sur };
  }

  /* KEPUTUSAN BOSS 20-09-2026: surcharge SELALU quantity 1, sekali per order,
     berapa pun jumlah chef atau assistant di keranjang.
     Alasannya, menagih lebih dari satu butuh penilaian mendalam di sisi klien
     soal kebutuhan manpower, dan itu bukan pekerjaan website. Admin yang
     melihat situasi dan memutuskan apakah perlu tagihan tambahan.
     chefCount di konfigurasi sengaja DIPERTAHANKAN tapi TIDAK dipakai untuk
     menghitung harga, supaya temuan soal paket berisi 2 sampai 3 assistant
     tidak hilang kalau nanti kebijakan ini ditinjau ulang. */
  var SURCHARGE_QTY = 1;

  function bookingFromCart(cart) {
    var a = cart.attributes || {};
    if (!a[ATTR.date]) return null;
    return {
      date: a[ATTR.date],
      time: a[ATTR.time] || '',
      duration: a[ATTR.duration] || '',
      guests: a[ATTR.guests] || '',
      notes: a[ATTR.notes] || ''
    };
  }

  /* Boss 30-09-2026: HANYA produk dengan scheduleNote (lamb saja, diatur di
     snippet) membawa satu baris tambahan untuk tim, karena GAF di /cart tetap
     meminta Delivery Date dan tanggalnya bisa berbeda dari acara. */
  var SCHEDULE_KEY = 'Schedule';
  var SCHEDULE_TEXT = 'Follow the Event Date and Booking Time above. Ignore the Delivery Date if it differs.';

  function propsFor(booking, band, variantId) {
    var p = {};
    p[ATTR.time]     = booking.time;
    p[ATTR.date]     = booking.date;
    p[ATTR.duration] = booking.duration;
    p[ATTR.guests]   = String(booking.guests);
    if (booking.notes) p[ATTR.notes] = booking.notes;
    p[ATTR.surcharge] = band
      ? money(band.amount) + ' (' + band.label + ')'
      : 'No surcharge';
    if (variantId !== undefined && entryFor(variantId).scheduleNote === true) p[SCHEDULE_KEY] = SCHEDULE_TEXT;
    return p;
  }

  function attrsFor(booking, band) {
    var a = {};
    a[ATTR.date]      = booking.date;
    a[ATTR.time]      = booking.time;
    a[ATTR.duration]  = booking.duration;
    a[ATTR.guests]    = String(booking.guests);
    a[ATTR.notes]     = booking.notes || '';
    a[ATTR.surcharge] = band ? money(band.amount) + ' (' + band.label + ')' : 'No surcharge';
    return a;
  }

  /* ======================================================================
     5. Rekonsiliasi. Enam aturan, tiap aturan menutup satu kegagalan
        yang benar benar pernah terjadi di order asli.
     ====================================================================== */

  /* Reconcile dijalankan BERURUT lewat satu rantai promise.

     Versi sebelumnya memakai flag `state.reconciling` sebagai penjaga masuk:
     kalau sedang berjalan, panggilan baru langsung pulang. Dua akibatnya, dan
     dua duanya sudah terjadi di live:
       1. Panggilan yang datang saat putaran lain berjalan HILANG, padahal
          justru dia yang tahu kondisi keranjang paling baru.
       2. Kalau satu putaran gagal di tengah tanpa mencapai baris penutup,
          flag itu macet `true` selamanya dan SEMUA reconcile berikutnya mati
          diam diam. Inilah yang membuat surcharge tidak terhapus waktu Boss
          mengubah tanggal lewat Edit.
     Sekarang tiap panggilan disambung ke ekor rantai, jadi tidak ada yang
     hilang, dan pelepasan flag ada di blok penutup yang selalu dijalankan
     baik saat sukses maupun gagal. */
  var reconcileChain = Promise.resolve();

  function reconcile() {
    reconcileChain = reconcileChain.then(runReconcileOnce, runReconcileOnce);
    return reconcileChain;
  }

  /* Indikator sibuk untuk reconcile, dinyalakan MALAS.

     Dulu busy(true) dipanggil di awal putaran. Itu keliru: reconcile berjalan
     di SETIAP page load dan sebagian besar kali tidak ada yang perlu diubah,
     jadi "Updating your cart..." berkedip di seluruh situs padahal tidak
     terjadi apa apa. (Boss, 20-09-2026) Sekarang penyalaannya pindah ke
     mark(), yaitu saat penulisan pertama ke Cart API benar benar dikirim.

     Pasangan on/off ini idempoten dan memakai satu penanda, bukan state.changed,
     karena ekor putaran sudah me-reset state.changed ke false SEBELUM .catch
     penutup bisa berjalan. Kalau pematiannya bergantung pada state.changed,
     ada jalur galat yang meninggalkan indikator menyala selamanya.
     Aman memakai penanda tingkat modul karena reconcile dijalankan berantai
     satu per satu lewat reconcileChain, tidak pernah tumpang tindih. */
  var reconcileBusy = false;
  function reconcileBusyOn()  { if (!reconcileBusy) { reconcileBusy = true;  busy(true); } }
  function reconcileBusyOff() { if (reconcileBusy)  { reconcileBusy = false; busy(false); } }

  function runReconcileOnce() {
    state.reconciling = true;
    state.changed = false;

    var selesaiRapi = function () {
      state.reconciling = false;
      reconcileBusyOff();
    };

    return getCart().then(function (cart) {
      var parts = splitCart(cart);
      var booking = bookingFromCart(cart);
      var band = booking ? bandFor(booking.date, booking.time) : null;
      var want = parts.chef.length ? SURCHARGE_QTY : 0;
      var chain = Promise.resolve();

      // aturan 1: tidak ada chef lagi, surcharge harus ikut hilang  (#3666)
      if (!parts.chef.length && parts.sur.length) {
        parts.sur.forEach(function (it) {
          chain = chain.then(function () { return mark(changeLine(it.key, { quantity: 0 })); });
        });
        if (booking) chain = chain.then(function () { return mark(setAttributes(blankAttrs())); });
        return chain;
      }

      if (!parts.chef.length) return chain;

      // aturan 2: tanggal sudah jauh, surcharge harus hilang
      if (!band && parts.sur.length) {
        parts.sur.forEach(function (it) {
          chain = chain.then(function () { return mark(changeLine(it.key, { quantity: 0 })); });
        });
        return chain;
      }

      if (!band) return chain;

      // aturan 6: lebih dari satu baris surcharge, sisakan satu  (#3666)
      var keep = null;
      parts.sur.forEach(function (it, i) {
        if (i === 0) keep = it;
        else chain = chain.then(function () { return mark(changeLine(it.key, { quantity: 0 })); });
      });

      // aturan 3: chef ada, surcharge tidak ada, tambahkan  (#3888)
      if (!keep) {
        chain = chain.then(function () {
          return mark(addItems([{ id: band.variantId, quantity: want, properties: surchargeProps(band) }]));
        });
        return chain;
      }

      // aturan 4: variant surcharge salah band, tukar
      if (Number(keep.variant_id) !== Number(band.variantId)) {
        chain = chain
          .then(function () { return mark(changeLine(keep.key, { quantity: 0 })); })
          .then(function () {
            return mark(addItems([{ id: band.variantId, quantity: want, properties: surchargeProps(band) }]));
          });
        return chain;
      }

      // aturan 5: quantity dikunci di 1, sekali per order  (#3666 tertagih 4x)
      if (keep.quantity !== want) {
        chain = chain.then(function () { return mark(changeLine(keep.key, { quantity: want })); });
      }

      return chain;
    })
      .catch(function () { /* fail open, diam saja */ })
      .then(function () {
        state.reconciling = false;          // dilepas sebelum render ulang
        var berubah = state.changed;
        state.changed = false;
        return getCart().then(function (c) {
          document.dispatchEvent(new CustomEvent('sbg:cart-updated', { detail: c }));
          var pr = berubah ? refreshCartView() : Promise.resolve();
          return pr.then(function () { reconcileBusyOff(); return c; });
        });
      })
      .catch(function () { selesaiRapi(); });
  }

  // Menandai bahwa keranjang benar benar berubah, supaya tampilan disegarkan.
  // Sekaligus titik penyalaan indikator: lihat keterangan di reconcileBusyOn.
  function mark(p) { reconcileBusyOn(); state.changed = true; return p; }

  /* Keterangan di baris surcharge. Boss sempat minta dikosongkan, lalu
     MEMBATALKANNYA setelah melihat hasilnya di live (20-09-2026): dua baris ini
     dipertahankan karena menjelaskan kenapa biaya muncul dan bagaimana
     menghilangkannya, tepat di tempat pelanggan melihatnya. */
  function surchargeProps(band) {
    return {
      'Why this charge': 'Your event is ' + bandSentence(band) + ' at the time of booking.',
      'How to remove': 'Change the Event Date on your booking.'
    };
  }

  function blankAttrs() {
    var a = {};
    Object.keys(ATTR).forEach(function (k) { a[ATTR[k]] = ''; });
    return a;
  }

  function scheduleReconcile() {
    clearTimeout(state.reconcileTimer);
    state.reconcileTimer = setTimeout(reconcile, 220);
  }

  /* Menyegarkan keranjang yang sudah terlanjur dirender.

     Versi pertama memakai location.reload() dengan pembatas anti loop di
     sessionStorage. Itu keliru: penghitungnya mentok setelah beberapa operasi
     lalu reload berhenti terjadi diam diam, sehingga server sudah berubah tapi
     layar tetap menampilkan angka lama. Sekarang halamannya dirender ulang di
     tempat, tanpa reload sama sekali, jadi tidak ada penghitung dan tidak ada
     kemungkinan loop. */
  function swap(doc, id) {
    var src = doc.getElementById(id);
    var dst = document.getElementById(id);
    if (!src || !dst) return;
    dst.innerHTML = src.innerHTML;
    if (typeof dst.ajaxifyCartItems === 'function') { try { dst.ajaxifyCartItems(); } catch (e) {} }
  }

  function refreshCartView() {
    var onCartPage = document.body.classList.contains('template-cart');
    var url = onCartPage
      ? (location.pathname + '?sbg=' + Date.now())
      : (ROOT + '?section_id=helper-cart&sbg=' + Date.now());

    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        swap(doc, 'AjaxCartForm');
        swap(doc, 'AjaxCartSubtotal');

        var cnt = document.querySelector('#AjaxCartForm [data-cart-count]');
        var tot = document.querySelector('#AjaxCartForm [data-cart-total]');
        if (cnt) document.querySelectorAll('[data-header-cart-count]').forEach(function (e) { e.textContent = cnt.textContent; });
        if (tot) document.querySelectorAll('[data-header-cart-total]').forEach(function (e) { e.textContent = tot.textContent; });

        if (onCartPage) {
          // halaman cart punya ringkasan sendiri di luar dua container itu
          ['cart-subtotal', 'CartSubtotal'].forEach(function (id) { swap(doc, id); });
          var sSrc = doc.querySelector('.cart__details, .cart-summary');
          var sDst = document.querySelector('.cart__details, .cart-summary');
          if (sSrc && sDst) sDst.innerHTML = sSrc.innerHTML;
        }
      })
      .catch(function () {});
  }

  /* Indikator sibuk. Boss meminta tanda kalau ada jeda, karena gerbang ini
     memang bicara ke Cart API Shopify dan itu perlu waktu. */
  /* Keranjangnya sedang terlihat atau tidak. Kalau pelanggan ada di homepage
     atau halaman produk, pekerjaan di latar belakang tidak perlu diumumkan,
     karena tidak ada yang bisa dia lihat berubah. (Boss, 20-09-2026)

     Halaman cart TIDAK dideteksi dari location.pathname, karena awalan lokal
     seperti /en-sg/cart akan meleset, dan tidak dari #AjaxCartForm, karena id
     itu dipakai ganda oleh drawer dan halaman cart. Liquid tahu pasti lewat
     template.name, jadi jawabannya dititipkan di konfigurasi.
     Kelas sidebar--opened dipasang dan dilepas oleh SidebarDrawer milik tema
     di section-header.js. */
  function cartVisible() {
    if (CFG.onCartPage) return true;
    var d = document.getElementById('site-cart-sidebar');
    return !!(d && d.classList.contains('sidebar--opened'));
  }

  var busyCount = 0;
  function busy(on) {
    busyCount = Math.max(0, busyCount + (on ? 1 : -1));
    // Hitungannya tetap berjalan seperti biasa. Yang disaring hanya tampilannya,
    // jadi tidak ada risiko hitungan jadi tidak seimbang.
    var nyala = busyCount > 0 && cartVisible();
    var el = document.getElementById('sbg-busy');
    if (!el) {
      if (!nyala) return;   // jangan pasang elemennya kalau memang tidak dipakai
      el = document.createElement('div');
      el.id = 'sbg-busy';
      el.className = 'sbg-busy sbg-root';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.innerHTML = '<span class="sbg-busy-dot"></span><span>Updating your cart...</span>';
      document.body.appendChild(el);
    }
    el.setAttribute('data-on', nyala ? 'true' : 'false');
  }

  /* ======================================================================
     6. Pantau perubahan keranjang dari mana pun (termasuk kode tema)
     ====================================================================== */

  (function watchCartMutations() {
    var orig = window.fetch;
    window.fetch = function (input, init) {
      var p = orig.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url) && url.indexOf(SELF) === -1) {
          p.then(function () { scheduleReconcile(); }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  })();

  /* ======================================================================
     7. Modal
     ====================================================================== */

  var ui = {};

  function cacheUI() {
    ui.overlay   = document.getElementById('sbg-overlay');
    if (!ui.overlay) return false;
    ui.subtitle  = document.getElementById('sbg-subtitle');
    ui.arrival   = document.getElementById('sbg-arrival-notice');
    ui.modeFull  = document.getElementById('sbg-mode-full');
    ui.modeQuick = document.getElementById('sbg-mode-quick');
    ui.summary   = document.getElementById('sbg-summary');
    ui.confirm   = document.getElementById('sbg-confirm');
    ui.change    = document.getElementById('sbg-change');
    ui.close     = document.getElementById('sbg-close');
    ui.time      = document.getElementById('sbg-booking-time');
    ui.date      = document.getElementById('sbg-event-date');
    ui.duration  = document.getElementById('sbg-duration');
    ui.guests    = document.getElementById('sbg-guests');
    ui.notes     = document.getElementById('sbg-notes');
    ui.sur       = document.getElementById('sbg-surcharge');
    ui.surAmt    = document.getElementById('sbg-surcharge-amount');
    ui.surBody   = document.getElementById('sbg-surcharge-body');
    ui.surCalc   = document.getElementById('sbg-surcharge-calc');
    ui.surQ      = document.getElementById('sbg-surcharge-quick');
    ui.surQAmt   = document.getElementById('sbg-surcharge-quick-amount');
    ui.surQCalc  = document.getElementById('sbg-surcharge-quick-calc');
    ui.dateHelp  = document.getElementById('sbg-date-help');
    ui.dateError = document.getElementById('sbg-date-error');
    ui.payWarn   = document.getElementById('sbg-paywarn');
    ui.payWarnB  = document.getElementById('sbg-paywarn-body');
    ui.payWarnQ  = document.getElementById('sbg-paywarn-quick');
    ui.payWarnQB = document.getElementById('sbg-paywarn-quick-body');
    ui.discFull  = document.getElementById('sbg-disclaimer-full');
    ui.discQuick = document.getElementById('sbg-disclaimer-quick');
    return true;
  }

  function fieldEl(name) { return document.querySelector('.sbg-field[data-field="' + name + '"]'); }

  function setInvalid(name, bad) {
    var f = fieldEl(name);
    if (f) f.setAttribute('data-invalid', bad ? 'true' : 'false');
  }

  function readForm() {
    return {
      date: ui.date.value,
      time: ui.time.value,
      duration: ui.duration.value,
      guests: ui.guests.value,
      notes: ui.notes.value.trim()
    };
  }

  function validate(showErrors) {
    var b = readForm();
    var ok = { time: !!b.time, date: !!b.date && b.date >= sgtPlusDays(state.rule.days),
               duration: !!b.duration, guests: !!b.guests && Number(b.guests) >= 1 };
    if (showErrors) Object.keys(ok).forEach(function (k) { setInvalid(k, !ok[k]); });
    return ok.time && ok.date && ok.duration && ok.guests;
  }

  function renderSurcharge() {
    var b = readForm();
    var band = (b.date && b.time) ? bandFor(b.date, b.time) : null;
    if (!band) { ui.sur.setAttribute('data-active', 'false'); return; }
    ui.sur.setAttribute('data-active', 'true');
    ui.surAmt.textContent = money(band.amount);
    ui.surBody.textContent =
      'Your event is ' + bandSentence(band) + '. A one-time last-minute fee applies to this booking ' +
      'and will be added to your cart as a separate item. It cannot be removed while a chef or ' +
      'assistant is in your cart. To remove it, choose an event date further ahead.';
    var hrs = hoursUntilEvent(b.date, b.time);
    ui.surCalc.textContent = 'Time until your event: about ' + Math.floor(hrs) + ' hours.';
  }

  /* Peringatan bayar hari ini (Boss 30-09-2026). Hanya untuk produk dengan
     minDays di atas 1, di hari minDays sampai minDays + PAY_WARN_EXTRA - 1. */
  var PAY_WARN_EXTRA = CFG.payWarnExtraDays > 0 ? CFG.payWarnExtraDays : 2;
  function payWarnText(dateStr) {
    var r = state.rule;
    if (!dateStr || !r || r.days <= 1) return '';
    var n = daysFromTodaySGT(dateStr);
    if (n === null || n < r.days || n >= r.days + PAY_WARN_EXTRA) return '';
    // Kalimat Boss 30-09-2026, grammar dirapikan. "whole lamb" ditulis tetap,
     // karena hanya lamb yang punya minDays di atas 1 saat ini.
    return 'Your date is ' + n + ' days away. Please complete your payment today to have your whole lamb ready in time.';
  }
  function renderPayWarn(box, body, dateStr) {
    if (!box || !body) return;
    var t = payWarnText(dateStr);
    body.textContent = t;
    box.setAttribute('data-active', t ? 'true' : 'false');
  }

  // Batas kalender, teks bantuan, dan disclaimer mengikuti state.rule.
  function applyRule() {
    var r = state.rule;
    ui.date.min = sgtPlusDays(r.days);
    if (ui.dateHelp && ui.dateError) {
      if (r.days <= 1) {
        ui.dateHelp.textContent = 'Earliest booking is tomorrow.';
        ui.dateError.textContent = 'Please choose an event date from tomorrow onwards.';
      } else {
        var nice = niceDate(sgtPlusDays(r.days));
        ui.dateHelp.textContent = r.title + ' needs at least ' + r.days + ' days\u2019 notice. Earliest booking is ' + nice + '.';
        ui.dateError.textContent = 'Please choose an event date from ' + nice + ' onwards.';
      }
    }
    if (ui.discFull) ui.discFull.hidden = !r.serviceOnly;
    if (ui.discQuick) ui.discQuick.hidden = !r.serviceOnly;
  }

  function openFull(productTitle, booking, mode, rule, opts) {
    state.mode = mode || 'add';
    var editing = state.mode === 'edit';
    opts = opts || {};
    state.rule = rule || { days: 1, title: productTitle, serviceOnly: true };
    if (opts.addServiceOnly !== undefined) state.addServiceOnly = opts.addServiceOnly;

    ui.modeFull.hidden = false;
    ui.modeQuick.hidden = true;
    ui.change.hidden = true;
    ui.confirm.textContent = editing ? 'Save booking details' : 'Confirm and Add to Cart';
    ui.subtitle.textContent = editing ? 'Applies to everything in your cart' : productTitle;
    var crew = 'Our crew will arrive 1 to 2 hours before your booking time to set up and prepare.';
    ui.arrival.textContent = editing
      ? (state.rule.serviceOnly
          ? 'Your chef or assistant will arrive 1 to 2 hours before your booking time to set up and prepare.'
          : crew)
      : (state.addServiceOnly
          ? 'Our ' + productTitle + ' will arrive 1 to 2 hours before your booking time to set up and prepare.'
          : crew);
    applyRule();
    if (booking) {
      ui.time.value = booking.time || '';
      ui.date.value = booking.date || '';
      ui.duration.value = booking.duration || '';
      ui.guests.value = booking.guests || '';
      ui.notes.value = booking.notes || '';
    }
    // Booking lama di keranjang terlalu dekat untuk produk ini: tanggalnya
    // dikosongkan dan pelanggan diminta memilih ulang untuk seluruh booking.
    if (opts.tooEarly && booking) {
      ui.arrival.textContent = 'Your cart already has a booking on ' + niceDate(booking.date) + '. ' +
        state.rule.title + ' needs at least ' + state.rule.days + ' days\u2019 notice, so please choose a new ' +
        'date. It will apply to everything in your cart.';
      ui.date.value = '';
    }
    // Boss 30-09-2026: kalimat kedatangan umum ("Our crew will arrive...") DIHAPUS
    // untuk whole lamb. Kalimat itu hanya dipakai produk non-jasa, dan saat ini
    // hanya lamb, jadi kotaknya disembunyikan tepat saat teks itu yang akan
    // tampil. Pesan "Your cart already has a booking..." tetap tampil. Pakai
    // style.display, karena .sbg-notice diberi display:flex sehingga atribut
    // hidden kalah.
    var arrivalBox = ui.arrival.closest ? ui.arrival.closest('.sbg-notice') : null;
    if (arrivalBox) arrivalBox.style.display = ui.arrival.textContent === crew ? 'none' : '';
    ['time', 'date', 'duration', 'guests'].forEach(function (n) { setInvalid(n, false); });
    renderSurcharge();
    renderPayWarn(ui.payWarn, ui.payWarnB, ui.date.value);
    show();
  }

  function openQuick(productTitle, booking, rule) {
    state.mode = 'add';
    state.rule = rule || { days: 1, title: productTitle, serviceOnly: true };
    applyRule();
    renderPayWarn(ui.payWarnQ, ui.payWarnQB, booking.date);
    ui.modeFull.hidden = true;
    ui.modeQuick.hidden = false;
    ui.change.hidden = false;
    ui.confirm.textContent = 'Confirm and Add to Cart';
    ui.subtitle.textContent = productTitle;

    var d = sgtInstant(booking.date, booking.time);
    var nice = d ? d.toLocaleDateString('en-SG', {
      weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', timeZone: 'Asia/Singapore'
    }) : booking.date;

    var rows = [
      ['Event Date', nice],
      ['Booking Time', booking.time],
      ['Dining Duration', booking.duration],
      ['Number of Guests', booking.guests]
    ];
    if (booking.notes) rows.push(['Additional Notes', booking.notes]);

    ui.summary.innerHTML = rows.map(function (r) {
      return '<div class="sbg-summary-row"><span class="sbg-summary-key">' + r[0] +
             '</span><span class="sbg-summary-val">' + escapeHtml(r[1]) + '</span></div>';
    }).join('');

    var band = bandFor(booking.date, booking.time);
    if (band) {
      ui.surQ.setAttribute('data-active', 'true');
      ui.surQAmt.textContent = money(band.amount);
      ui.surQCalc.textContent = 'Already applied to this booking. Adding another ' + productTitle +
        ' will not charge it again.';
    } else {
      ui.surQ.setAttribute('data-active', 'false');
    }
    show();
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function show() {
    // Tutup cart drawer kalau sedang terbuka. Tanpa ini, pelanggan yang menambah
    // chef dari rekomendasi di dalam drawer melihat dua panel bertumpuk.
    try {
      var sidebar = document.getElementById('site-cart-sidebar');
      if (sidebar && typeof sidebar.hide === 'function') sidebar.hide();
    } catch (e) {}

    ui.overlay.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { ui.overlay.focus(); }, 30);
  }

  function hide() {
    ui.overlay.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
    state.form = null;
    state.variantId = null;
  }

  /* ======================================================================
     8. Gerbang. Intersepsi di fase CAPTURE pada document, supaya selalu
        berjalan sebelum listener submit milik <product-form> tema.
     ====================================================================== */

  /* Form mana yang dijaga. Form vendor (data-type="add-to-cart-form") seperti
     sebelumnya. Sejak 30-09-2026 form lain yang action-nya ke /cart/add, yaitu
     form v2 shiok-product-main-v2 milik halaman lamb, ikut dijaga HANYA untuk
     variant non-jasa. Chef/assistant tidak berubah sama sekali. */
  function isGateForm(form, variantId) {
    if (!isGated(variantId)) return false;
    if (form.matches('form[data-type="add-to-cart-form"]')) return true;
    return form.matches('form[action*="/cart/add"]') && !isServiceOnly(variantId);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches) return;
    if (form.dataset.sbgPassed === '1') return;          // sudah lolos gerbang

    var idInput = form.querySelector('input[name="id"]');
    if (!idInput || !isGateForm(form, idInput.value)) return;  // bukan produk yang dijaga

    e.preventDefault();
    e.stopPropagation();                                  // blokir listener tema

    state.form = form;
    state.variantId = idInput.value;

    gateOpen(idInput.value);
  }, true);

  /* Membuka modal untuk variant yang sedang ditambahkan. Syaratnya produk
     terberat di keranjang plus variant ini. Booking yang sudah ada dipakai
     ulang (mode cepat) selama tanggalnya memenuhi syarat itu; kalau tidak,
     form penuh dibuka dengan tanggal dikosongkan. Untuk syarat 1 hari
     (chef/assistant) mode cepat selalu dipakai, persis seperti sebelumnya. */
  function gateOpen(variantId) {
    var title = entryFor(variantId).productTitle || 'chef';
    var addSO = isServiceOnly(variantId);
    state.addServiceOnly = addSO;
    getCart().then(function (cart) {
      var booking = bookingFromCart(cart);
      state.booking = booking;
      var ids = splitCart(cart).chef.map(function (it) { return it.variant_id; });
      var rule = ruleFor(ids.concat([variantId]));
      var tooEarly = !!booking && rule.days > 1 && booking.date < sgtPlusDays(rule.days);
      if (booking && !tooEarly) openQuick(title, booking, rule);
      else openFull(title, booking, 'add', rule, { tooEarly: tooEarly, addServiceOnly: addSO });
    }).catch(function () {
      state.booking = null;
      openFull(title, null, 'add', ruleFor([variantId]), { addServiceOnly: addSO });
    });
  }

  /* ======================================================================
     9. Confirm
     ====================================================================== */

  function passThrough(booking, band) {
    var form = state.form;
    if (!form) { hide(); return; }

    // buang suntikan lama, lalu suntik properti baru KE DALAM form
    form.querySelectorAll('input[data-sbg-injected]').forEach(function (n) { n.remove(); });
    var props = propsFor(booking, band, state.variantId);
    Object.keys(props).forEach(function (k) {
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = 'properties[' + k + ']';
      i.value = props[k];
      i.setAttribute('data-sbg-injected', '1');
      form.appendChild(i);
    });

    form.dataset.sbgPassed = '1';
    hide();

    var btn = form.querySelector('[type="submit"]');
    if (form.requestSubmit) form.requestSubmit(btn || undefined);
    else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));

    setTimeout(function () { delete form.dataset.sbgPassed; }, 1500);
  }

  function setConfirmBusy(on, label) {
    if (!ui.confirm) return;
    ui.confirm.disabled = !!on;
    ui.confirm.setAttribute('data-busy', on ? 'true' : 'false');
    if (on) {
      if (!ui.confirm.dataset.labelBefore) ui.confirm.dataset.labelBefore = ui.confirm.textContent;
      ui.confirm.textContent = label || 'Saving...';
    } else if (ui.confirm.dataset.labelBefore) {
      ui.confirm.textContent = ui.confirm.dataset.labelBefore;
      delete ui.confirm.dataset.labelBefore;
    }
  }

  function onConfirm() {
    var isQuick = ui.modeQuick.hidden === false;
    var booking = isQuick ? state.booking : readForm();

    if (!isQuick && !validate(true)) return;

    var band = bandFor(booking.date, booking.time);
    var editing = state.mode === 'edit';

    // Modal SENGAJA tidak langsung ditutup. Menyimpan booking berarti bicara ke
    // Cart API Shopify beberapa kali, dan itu perlu waktu. Kalau modal ditutup
    // duluan, pelanggan melihat keranjang lama dan mengira perubahannya gagal.
    setConfirmBusy(true, editing ? 'Saving...' : 'Adding to cart...');
    busy(true);

    var selesai = function () { setConfirmBusy(false); busy(false); };

    setAttributes(attrsFor(booking, band))
      .catch(function () {})
      .then(function () { return applyToExistingLines(booking, band); })
      .catch(function () {})
      .then(function () {
        if (editing) {
          state.mode = 'add';
          // Properti tiap baris ikut berubah walaupun surcharge tidak berubah,
          // jadi tampilan tetap harus dirender ulang setelah reconcile selesai.
          return reconcile()
            .then(function () { return refreshCartView(); })
            .then(function () { selesai(); hide(); });
        }
        selesai();
        passThrough(booking, band);
      })
      .catch(function () { selesai(); hide(); });
  }

  // kalau booking diubah, semua baris chef/assistant yang sudah ada ikut diperbarui
  function applyToExistingLines(booking, band) {
    return getCart().then(function (cart) {
      var parts = splitCart(cart);
      if (!parts.chef.length) return;
      var chain = Promise.resolve();
      parts.chef.forEach(function (it) {
        var props = propsFor(booking, band, it.variant_id);
        chain = chain.then(function () { return changeLine(it.key, { properties: props }); });
      });
      return chain;
    });
  }

  /* ======================================================================
     9b. Link "Edit" di keranjang.
         Bar ringkasan booking dihapus atas permintaan Boss (20-09-2026).
         Penggantinya link Edit kecil di sebelah Remove, dirender oleh
         snippets/cart-form.liquid dan cart-form-page.liquid pada baris yang
         punya data booking. Tanpa ini, keterangan pada baris surcharge
         ("change the Event Date on your booking") jadi instruksi buntu.
     ====================================================================== */

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-sbg-edit]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    getCart().then(function (cart) {
      var booking = bookingFromCart(cart);
      if (!booking) return;
      state.form = null;
      state.booking = booking;
      var ids = splitCart(cart).chef.map(function (it) { return it.variant_id; });
      openFull('', booking, 'edit', ruleFor(ids));
    });
  }, true);

  /* ======================================================================
     10. Bind
     ====================================================================== */

  function init() {
    if (!cacheUI()) return;

    ui.confirm.addEventListener('click', onConfirm);
    ui.close.addEventListener('click', hide);
    ui.change.addEventListener('click', function () {
      openFull(ui.subtitle.textContent, state.booking, 'add', state.rule, { addServiceOnly: state.addServiceOnly });
    });
    ui.overlay.addEventListener('click', function (e) { if (e.target === ui.overlay) hide(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && ui.overlay.getAttribute('data-open') === 'true') hide();
    });

    ['change', 'input'].forEach(function (ev) {
      ui.date.addEventListener(ev, function () {
        renderSurcharge(); setInvalid('date', false);
        renderPayWarn(ui.payWarn, ui.payWarnB, ui.date.value);
      });
      ui.time.addEventListener(ev, function () { renderSurcharge(); setInvalid('time', false); });
    });
    ui.duration.addEventListener('change', function () { setInvalid('duration', false); });
    ui.guests.addEventListener('input', function () { setInvalid('guests', false); });

    // Klik di mana pun pada field tanggal membuka kalender, bukan cuma di ikonnya.
    // showPicker() butuh gesture pengguna, jadi dipasang di click. Kalau browser
    // menolak (atau belum mendukung), perilaku bawaan tetap jalan.
    function openDatePicker(e) {
      if (typeof ui.date.showPicker !== 'function') return;
      try { ui.date.showPicker(); if (e) e.preventDefault(); } catch (err) {}
    }
    ui.date.addEventListener('click', openDatePicker);
    ui.date.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') openDatePicker(e);
    });

    ui.date.min = tomorrowSGT();


    // Ambil alih dari penjaga awal di snippet. Kalau pelanggan sempat menekan
    // Add to Cart sebelum skrip ini termuat, form-nya ditahan di sana dan
    // dilanjutkan di sini, jadi kliknya tidak hilang percuma.
    window.__SBG_READY__ = true;
    if (typeof window.__SBG_EARLY_OFF__ === 'function') window.__SBG_EARLY_OFF__();
    var pending = window.__SBG_PENDING__;
    window.__SBG_PENDING__ = null;
    if (pending && pending.isConnected) {
      var pid = pending.querySelector('input[name="id"]');
      if (pid && isGateForm(pending, pid.value)) {
        state.form = pending;
        state.variantId = pid.value;
        gateOpen(pid.value);
      }
    }

    /* Hitung ulang band, TAPI hanya kalau keranjang memang berisi chef,
       assistant, atau baris surcharge. Tanpa salah satunya, runReconcileOnce
       terbukti tidak melakukan apa apa: aturan 1 butuh baris surcharge, dan
       aturan 2 sampai 6 langsung dilewati oleh `if (!parts.chef.length) return`.
       Jadi melewatinya menghemat dua panggilan /cart.js di hampir setiap
       kunjungan, tanpa mengubah hasil apa pun.

       Perhatikan !== false: kalau konfigurasi lama masih ter-cache dan kunci
       ini belum ada, perilakunya kembali seperti sebelumnya, bukan mati diam. */
    if (CFG.cartNeedsReconcile !== false) scheduleReconcile();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.SBG = { reconcile: reconcile, bandFor: bandFor, hoursUntilEvent: hoursUntilEvent, config: CFG };
})();
